import * as React from "react"
import "../styles/mystyles.scss"
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import IntroSection from '../components/IntroSection'
import SalesSection from '../components/SalesSection'
import PurchaseSection from '../components/PurchaseSection'
import AboutSection from '../components/AboutSection'
import ContactSection from '../components/ContactSection'
import Footer from '../components/Footer'
import { Helmet } from "react-helmet"

const IndexPage = () =>
{
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale = 1.0, 
        maximum-scale=1.0, user-scalable=no" />
      </Helmet>

      <Navbar introduction="Introduction" purchase="Purchase" sale="Sale" about="About us" webshop="Webshop" contact="Contact" page="/eng-index" selectedCountry="united-kingdom" possibleCountry="netherlands" countryLink="/" />

      <Hero page="/eng-index" description={["Tire wholesaler specialized", <br />, "in DOT and DEMO tires. With weekly", <br />,
        "new stock and shipping with", <br />, "DPD throughout Europe.", <br />, <br />]} button="Read more" />

      <IntroSection description={["Dutch Tyres, the tyre wholesaler focused on DOT and DEMO tyres. ",
        "We have a wide range of A brands tyres in stock and we ship daily via our warehouse in Grave, the Netherlands. ",
        "Weekly new stock and shipment through Europe. More info about our stock? Contact us: ", <a>nicky@dutchtyres.nl</a>, <br />, <br />,
        "Dutch Tyres has it origins as Tyre Service P. van Raay. After 40 years of changing tyres for our customers in the area of Nijmegen we started to focus more on wholesale. ",
        "Piet has been active in the tyre industry for years and daughter Nicky is active in the company since 2016. From that moment the focus came more on wholesale and online sales. ",
        "In 2022 we stopped with the tyre service and only continued our function as wholesale, Dutch Tyres."]} />

      <PurchaseSection title="Purchase" description={["Dutch Tyres is an independent tyre wholesaler. We are interested in new, demounted (DEMO) and older production (DOT) tyres of all brands and sizes. ", <br />, <br />,
        "Dutch Tyres hat its own storage location in Nijmegen. All offered tyres are owned by us, we do not sell tyres that are not stored in our warehouse. ",
        "This means that offers are handled discrete and our purchase process is short. ", <br />, <br />,
        "Are you looking for a buyer for your tyres? Dutch Tyres is always looking for new partners. Please contact us at ", <a>lorenzo@dutchtyres.nl</a>]} />,

      <SalesSection title="Sale" description={["Dutch Tyres has a wide range of new tyres in stock in summer, winter, allseason and van tyres. ",
        "Are you looking for specific sizes or brands? Or would you like to receive a weekly overview of our stock. Please contact us. ",
        <br />, <br />, "Orders that take place before 10:00 will be shipped the same day. We ship our tyres with DPD through Europa."]} />

      <AboutSection title="About us" description={["What started in 1981 with an gas station owned by Piet van Raay, slowly transformed into ",
        "a tyre trading company and tyre service in the future years. In 1993 the gas station was cleaned up and the focus came ",
        "completely on tyre trading and tyre service.", <br />, <br />, "After many years of being active as tyre service the focus came more on wholesale the last years. ",
        "Daughter Nicky stepped into the company in 2016 and a new sales channel, online selling, was created. In 2021 the decision was made to completely ",
        "stop with the tyre service and continue only as a wholesaler. This created Dutch Tyres in 2022, an independent tyre wholesaler with a focus on DOT and DEMO tyres."]} />

      <ContactSection intro="Contact us" addresstitle="Address" address={["Koninginnedijk 730", <br />, "5361CR Grave", <br />, "The Netherlands"]} email="Mail" />

      <Footer />
    </>
  )
}

export default IndexPage
